import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  height: 90vh;
  .ant-table-thead .ant-table-cell {
    background-color: white;
    color: #8c8c8c;
    font-weight: 600;
  }

  .highlight-row {
    background-color: #f8d7da; 
    font-weight: bold;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 0px;
  :hover {
    cursor: help;
  }
`;

export { Container, TitleContainer };
